import { useEventTracking } from '../../../../helpers/gtmHelper'
import { CAF_ANALYSIS_TYPE_MAP } from '../../../../model/caf.interface'
import { useCafLessonDiffFeedbackV5, useCafLessonDiffV5 } from '../../../../modules/apis/student/lesson'
import { CAF_LEVEL_MAX, WEB_CAF_OVERVIEW_SIDE_MENU } from '../../../../modules/consts/caf'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { useMapCAFTotalLevel } from '../../../../modules/hooks/webview/caf/common/findWordingKey'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../common/LoadingSpinner'
import ProgressBox from '../common/ProgressBox'
import ThickDivider from '../common/ThickDivider'

const OverviewIntroSection = ({ data, isLoading, lessonId }) => {
  const { t } = useTranslation()
  const { returnCAFTotalLevel } = useMapCAFTotalLevel()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()
  const router = useAppRouter()
  const { data: diffData } = useCafLessonDiffV5()
  const { navigate } = useWebviewNavigation()
  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const { data: diffFeedbackData } = useCafLessonDiffFeedbackV5()
  const { sendPageViewEvent } = useEventTracking()

  const goToDetailPage = (type: string, componentId) => {
    if (isWebview) {
      switch (type) {
        case 'complexity':
          sendPageViewEvent({ page_name: 'ai_complexity_metric' })
          push(LESSON_ACTIVITIES_MAP.AIComplexityActivity, { lessonId, componentId })
          break
        case 'accuracy':
          sendPageViewEvent({ page_name: 'ai_accuracy_metric' })
          push(LESSON_ACTIVITIES_MAP.AIAccuracyActivity, { lessonId, componentId })
          break
        case 'fluency':
          sendPageViewEvent({ page_name: 'ai_fluency_metric' })
          push(LESSON_ACTIVITIES_MAP.AIFluencyActivity, { lessonId, componentId })
          break
        case 'pronunciation':
          sendPageViewEvent({ page_name: 'ai_pronunciation_metric' })
          push(LESSON_ACTIVITIES_MAP.AIPronunciationActivity, { lessonId, componentId })
          break
      }
    } else if (isMobile) {
      const url = urls.webview.caf.analysis.index(type, componentId)
      navigate({ url: url + `?lessonId=${lessonId}` }) // newPage true
    } else {
      const index = WEB_CAF_OVERVIEW_SIDE_MENU.findIndex((menuItem) => menuItem.name === type)
      if (index >= 0) {
        router.push(urls.student.newPortal.lessons.reviewDetail.asCafComponent(lessonId, index, componentId))
      }
    }
  }
  const cafComponentsArray = (compArray) => {
    return compArray?.filter((compItem) => compItem.component_tag !== 0)
  }
  if (isLoading || !data)
    return (
      <div className="flex h-[100px] w-screen items-center justify-center">
        <LoadingSpinner show primary />
      </div>
    )
  const totalLevel = returnCAFTotalLevel(cafComponentsArray(data.components)).slice(0, 3)

  if (isMobile) {
    return (
      <>
        <section className="w-full pb-[16px]">
          {cafComponentsArray(data.components)?.map((overviewItem) => (
            <ProgressBox
              key={overviewItem.id + 'overview'}
              title={overviewItem.name}
              levelRough={overviewItem.level_rough}
              levelExact={overviewItem.level_exact}
              totalNum={CAF_LEVEL_MAX}
              componentTag={overviewItem.component_tag}
              type={CAF_ANALYSIS_TYPE_MAP[overviewItem.component_tag] as unknown as CAF_ANALYSIS_TYPE_MAP}
              onClick={() => goToDetailPage(CAF_ANALYSIS_TYPE_MAP[overviewItem.component_tag], overviewItem.id)}
              mr={0}
              diffData={diffData}
            />
          ))}
          <p className="text-sBody mt-[16px]">
            {diffFeedbackData?.feedback || t(n_caf.overview[`caf_level${totalLevel}`])}
          </p>
          {/* <p className="text-sBody mt-[16px]">{t(n_caf.overview[`caf_level${totalLevel}`])}</p> */}
        </section>{' '}
        <ThickDivider />
      </>
    )
  } else {
    return (
      <>
        <section className="pb-[32px]">
          <div className="flex w-[596px] flex-wrap gap-[16px] sm:w-[352px] lg:w-[596px] xl:w-[688px]">
            {cafComponentsArray(data.components)?.map((overviewItem, i) => (
              <ProgressBox
                key={overviewItem.id + 'overview'}
                title={overviewItem.name}
                levelRough={overviewItem.level_rough}
                levelExact={overviewItem.level_exact}
                totalNum={CAF_LEVEL_MAX}
                type={CAF_ANALYSIS_TYPE_MAP[overviewItem.component_tag] as unknown as CAF_ANALYSIS_TYPE_MAP}
                onClick={() => goToDetailPage(CAF_ANALYSIS_TYPE_MAP[overviewItem.component_tag], overviewItem.id)}
                mr={i === 2 ? 0 : 16}
                diffData={diffData}
                componentTag={overviewItem.component_tag}
              />
            ))}
          </div>
          <p className="mt-[16px] text-[16px] text-gray-600">
            {diffFeedbackData?.feedback || t(n_caf.overview[`caf_level${totalLevel}`])}
          </p>
        </section>
        <ThickDivider />
      </>
    )
  }
}
export default OverviewIntroSection
